import { MenuInterface } from '../../../entities';

export const HeaderMenus: { globalMenu: MenuInterface[]; primary: MenuInterface[]; secondary: MenuInterface[] } = {
  globalMenu: [],
  primary: [
    {
      href: 'https://it.benzinga.com/news/italy/',
      label: 'Notizie dall’Italia',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://it.benzinga.com/news/italy/stocks/', label: 'Azioni', title: 'Azioni' },
          { href: 'https://it.benzinga.com/news/italy/indices/', label: 'Indici', title: 'Indici' },
          { href: 'https://it.benzinga.com/news/italy/bonds/', label: 'Obbligazioni', title: 'Obbligazioni' },
          { href: 'https://it.benzinga.com/news/italy/etfs/', label: 'ETF', title: 'ETF' },
          { href: 'https://it.benzinga.com/news/italy/economy/', label: 'Economia', title: 'Economia' },
          { href: 'https://it.benzinga.com/news/italy/general/', label: 'Generale', title: 'Generale' },
        ],
      },
    },
    {
      href: 'https://it.benzinga.com/news/usa/',
      label: 'Notizie USA',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://it.benzinga.com/news/usa/stocks/',
            label: 'Azioni',
            title: 'Azioni',
          },
          {
            href: 'https://it.benzinga.com/news/usa/indices/',
            label: 'Indici',
            title: 'Indici',
          },
          {
            href: 'https://it.benzinga.com/news/usa/earnings/',
            label: 'Utili',
            title: 'Utili',
          },
          {
            href: 'https://it.benzinga.com/news/usa/economy/',
            label: 'Notizie Economiche',
            title: 'Notizie Economiche',
          },
          {
            href: 'https://it.benzinga.com/news/usa/predictionmarkets/',
            label: 'Mercati di previsione',
            title: 'Mercati di previsione',
          },
          {
            href: 'https://it.benzinga.com/news/usa/privatemarkets/',
            label: 'Mercati privati',
            title: 'Mercati privati',
          },
          {
            href: 'https://it.benzinga.com/news/usa/othermarkets/',
            label: 'Altri Mercati',
            title: 'Altri Mercati',
          },
          {
            href: 'https://it.benzinga.com/news/usa/analystratings/',
            label: 'Dicono gli Analisti',
            title: 'Dicono gli Analisti',
          },
          {
            href: 'https://it.benzinga.com/news/usa/trading/',
            label: 'Trading',
            title: 'Trading',
          },
          {
            href: 'https://it.benzinga.com/news/usa/press-releases/',
            label: 'Comunicati stampa',
            title: 'Comunicati stampa',
          },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://it.benzinga.com/news/global/',
      label: 'Notizie internazionali',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://it.benzinga.com/news/global/europe/',
            label: 'Europa',
            title: 'Europa',
          },
          {
            href: 'https://it.benzinga.com/news/global/asia/',
            label: 'Asia',
            title: 'Asia',
          },
        ],
      },
    },
    {
      href: 'https://it.benzinga.com/crypto/',
      label: 'Criptovalute',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://it.benzinga.com/crypto/news/',
            label: 'Notizie',
            title: 'Notizie',
          },
          {
            href: 'https://it.benzinga.com/crypto/altcoins/',
            label: 'Altcoin',
            title: 'Altcoin',
          },
          {
            href: 'https://it.benzinga.com/crypto/bitcoin/',
            label: 'Bitcoin',
            title: 'Bitcoin',
          },
          {
            href: 'https://it.benzinga.com/crypto/blockchain/',
            label: 'Blockchain',
            title: 'Blockchain',
          },
          {
            href: 'https://it.benzinga.com/crypto/dogecoin/',
            label: 'Dogecoin',
            title: 'Dogecoin',
          },
          {
            href: 'https://it.benzinga.com/crypto/ethereum/',
            label: 'Ethereum',
            title: 'Ethereum',
          },
          {
            href: 'https://it.benzinga.com/crypto/shibainu/',
            label: 'Shiba Inu',
            title: 'Shiba Inu',
          },
          {
            href: 'https://it.benzinga.com/crypto/nfts/',
            label: 'NFT',
            title: 'NFT',
          },
        ],
      },
    },
    {
      href: 'https://it.benzinga.com/education/',
      label: 'Finanza personale',
      subGroupChevron: true,
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          {
            href: 'https://it.benzinga.com/education/crypto/',
            label: 'Investire in criptovalute',
            title: 'Investire in criptovalute',
          },
          {
            href: 'https://it.benzinga.com/education/stocks/',
            label: 'Investire in azioni',
            title: 'Investire in azioni',
          },
          {
            href: 'https://it.benzinga.com/education/forex/',
            label: 'Forex',
            title: 'Forex',
          },
        ],
      },
    },
  ],
  secondary: [],
};
